import SiderLayout from "../../layouts/SiderLayout";
import { BillingSlider } from "../../pages/Billing/BillSlider/BillingSlider";
import React from "react";
import routes from "../routes";
import { generateChildren } from "./RouterGenerator";

let childrenNormal = generateChildren([
  routes.billing().detail,
  routes.billing().edition,
]);

export const billingRouter = [
  {
    path: routes.billing().path,
    handle: {
      crumb: e => routes.billing().ressourceCrumb(e),
    },
    element: (
      <SiderLayout>
        <BillingSlider />
      </SiderLayout>
    ),
    children: [
      {
        path: routes.billing().detail.path,
        handle: {
          crumb: e => routes.billing().crumb(e),
        },
        children: childrenNormal,
      },
    ],
  },
];
